import React, { useEffect, useState } from "react";
import { ModalPadrao } from "../../components/Base";
import { Input } from "antd";
import { BtnGravar, BtnSair } from "../../components/Buttons";

function ModalObs({ visible, onCancel, observacao, onOk }) {
  const [obs, setObs] = useState();

  useEffect(() => setObs(observacao), [visible]);

  return <ModalPadrao
    closable={false}
    width={window.innerWidth < 850 ? window.innerWidth : 850}
    visible={visible}
    title="Observação da venda"
    okText="Confirmar"
    cancelText="Sair"
    footer={<>
      <BtnGravar onClick={() => onOk(obs)} />
      <BtnSair onClick={onCancel} />
    </>}
  >
    <Input.TextArea placeholder="Insira a observação" style={{ height: 350 }} value={obs} onChange={v => setObs(v.target.value)} />
  </ModalPadrao>;
}

export default ModalObs;
